import React from 'react'

import Header from './cheader'
import Footer from './footer'

export default ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
)
